module.exports = __webpack_public_path__ + "img/hr.a0c9f89.svg";